import React, { ReactElement } from "react";
import { TicketMessage } from "../../../../../__generated__/api";
import { tryParseDate } from "../../../../../date";
import { HtmlRenderer } from "../../../../html-render/HtmlRenderer";
import Styles from "./MessageCard.module.scss";
import Time from "../../../../time/Time";

export default function SystemMessageCard({ message }: {message: TicketMessage}): ReactElement {
    const date = tryParseDate(message.createdDate);

    return (
        <div className={Styles["system-message"]}>
            <Time date={date} variant="time" className={Styles.time} />
            <div className="message-line">
                {/* <RiArrowLeftRightLine /> */}
                {message.body.html && (
                    <HtmlRenderer html={message.body.html} />
                )}

            </div>

        </div>
    );
}
